// Online Javascript Editor for free
// Write, Edit and Run your Javascript code using JS Online Compiler
export default class UndoRedo{
    
    constructor(){
        this.position=-1
        this.data=[]
        this.size=10
    }
    get getPosition(){
        return this.position
    }
    
    get getData(){
        return this.data
    }
    get top(){
        return this.data[this.position]
    }
    get getPreviousState(){
        this.setPosition(this.position-1)
        return this.data[this.position]

    }
    get getNextState(){
        this.setPosition(this.position+1)
        return this.data[this.position]
    }
    setPosition(pos){
        this.position=pos
    }
    push(data){
        
        if(this.position!==-1 && this.position!==this.data.length-1){
            let currentData=this.data[this.position]
            this.data=[...this.data.slice(0,this.position),...this.data.slice(this.position,this.data.length)]
            this.data=[...this.data,currentData,data]
            this.position=this.data.length-1
        }else{
        this.position=this.position+1
        this.data=[...this.data,data]
        }
        if(this.data.length>=this.size){
            this.removeFromStart()
        }
    }
    
    removeFromStart(){
        this.data=this.data.slice(1,this.data.length)
        this.position=this.position-1
    }
    
}

